const failedAccountColumns = [
	{ field: 'maskedAccNumber', header: 'Masked Account Number' },
	{ field: 'fipId', header: 'FIP ID' },
	{ field: 'accType', header: 'Account Type' },
	{ field: 'fiType', header: 'FI Type' },
];

export default failedAccountColumns;
